import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
// States
import { ChangeEventItemOnChannelAction } from '../../../../signal-r/action/signal-r.action';
// Models
import { ORDER_EVENT_TYPE, ORDER_EVENT_TYPES } from '../../../../model/order-event-type.model';
// Services
import { AppService } from '../../../../service/app.service';
import { CvDateFormatter } from '@cv-invision/cv.component-library.ux';

@Component({
	selector: 'cv-order-event-notification',
	templateUrl: './order-event-notification.component.html',
	styleUrls: ['./order-event-notification.component.scss']
})
export class OrderEventNotificationComponent implements OnChanges {
	@Input() orderEvent: any;
	@Input() module: string;
	@Output() toggleInbox: EventEmitter<any> = new EventEmitter<any>();
	mainUrl: string;

	constructor(
		private store: Store,
		private router: Router,
		private appService: AppService,
		private dateService: CvDateFormatter
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['module']) {
			const url = this.appService.getMainModuleUrl(changes['module'].currentValue);

			this.mainUrl = url;
		}
	}

	/**
	 * Open the order when clicking on the event
	 */

	openEvent(event: any): void {
		this.toggleInbox.emit();
		this.store.dispatch(new ChangeEventItemOnChannelAction('orders', event, 'orderId'));
		this.router.navigate([this.mainUrl, event.data.orderId]).catch(e => console.warn(e));
	}

	/**
	 * Get time from now
	 * @param timestamp
	 */
	getTimeFrom(timestamp: number): string {
		return this.dateService.fromNow(timestamp);
	}

	/**
	 * Returns true if is Valid know order event type.
	 */
	isValidOrderEvent(): boolean {
		return ORDER_EVENT_TYPES.includes(this.orderEvent.event);
	}

	/**
	 * Returns the corresponding notification message.
	 */
	getNotificationMessage(): string {
		switch (this.orderEvent.event) {
			case ORDER_EVENT_TYPE.ORDER_CREATED:
				return 'A new order has been added.';
			default:
				return '';
		}
	}
}
